import React from 'react';
import AdminElectricalStylePricingEditor from './AdminElectricalStylePricingEditor';

const SERVICES = {
  600: { name: 'Furniture Assembly' },
  601: { name: 'General Property Maintenance' },
  602: { name: 'Planned Preventative Maintenance' },
  603: { name: 'Reactive Maintenance' },
  604: { name: 'Wall Mounting' },
};

const AdminPropertyMaintenancePricingRules = ({ isTabMode = false }) => (
  <AdminElectricalStylePricingEditor
    services={SERVICES}
    title="Property Maintenance & Handyman Pricing Rules"
    description="Manage pricing for 5 property maintenance services"
  />
);

export default AdminPropertyMaintenancePricingRules;
